// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__2VS5E"};